module.exports = __webpack_public_path__ + "static/media/MuliRegular.80faded9.ttf";